import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Link } from 'gatsby'

const Wrapper = styled.section`
  position: relative;
  min-height: 300px;
`

const Title = styled.h1`
    margin-bottom: 0.3em;
    font-size: 4em;
    line-height: 1.3;
    color: white;

    /* Checks if chrome is used, and sets the front page mobile hero titles font size to scale with the window. */
    @media (max-width: ${props => props.theme.responsive.small}) {
        font-size: ${ props => props.isAndroidChrome
        ? '16vw'
        : '4em'};
    }

    @media (max-width: ${props => props.theme.responsive.medium}) {
        text-align: center;
        word-break: break-word;
        hyphens: auto;
    }
`

const SmallTitle = styled.div`
  color: #FFFFFF;
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.6;
  font-weight: 100;
`

const TextContainer = styled.div`
  position: relative;
`

const Text = styled.div`
  @media (max-width: ${props => props.theme.responsive.medium}) {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }

  p {
    font-weight: 100;
  }

  a {
    color: white;
  }
`

const TextWrapper = styled.div`
  position: absolute;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  padding: 0 1rem;
  top: 0; left: 0; bottom: 0; right: 0;
  color: white;
  margin:auto;
  margin-top: 1em;

  @media only screen and (min-width: ${props => props.theme.responsive.medium}) and (max-width: ${props => props.theme.responsive.large}) {
    top: 50%;
  }

  @media (min-width: ${props => props.theme.responsive.large}) {
    top: 50%;
  }
`

const BgImg = styled(Img)`
  position: absolute;
  top: 50;
  left: 0;
  width: 100%;
  min-height: 600px;
  z-index: -1;
  &.small {
    min-height: 100px;
  }
  &.small ~${TextWrapper} {
    top: 20% !important;
    text-align: center;
    ${TextContainer} {
      ${Title} {
        font-size: 40px;
        // Checks if chrome is used, and sets the mobile hero small titles font size to scale with the window.
        @media (max-width: ${props => props.theme.responsive.small}) {
        font-size: ${ props => props.isAndroidChrome
        ? '9vw'
        : '40px'}};
        }
      }
    }
  }
  @media (max-width: ${props => props.theme.responsive.small}) {
    width: 135%;
    margin-left: -35%;
  }

  height: 100%;
  & > img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
  }
  &::before {
    content: '';
    background: rgba(0, 0, 0, 0);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

`

class Hero extends React.Component {
    constructor(props) {
        super(props)
        this.state = { width: 0 }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth })
    }

    render() {
        const {
            descriptionIsLink,
            header,
            androidChromeHyphenatedTitle
        } = this.props

        let isAndroidChrome = false
        if (typeof navigator !== 'undefined') {
            isAndroidChrome =
              navigator.appVersion.indexOf('Chrome/') !== -1
              &&
              (navigator.platform === 'Android' ||
                  navigator.platform.includes('Linux')) ||
                  navigator.platform === null
        }

        return (
            this.props.image &&
                <Wrapper className={this.props.className}>
                    <BgImg
                        className={this.props.top}
                        fluid={this.props.image.fluid}
                        isAndroidChrome={isAndroidChrome}
                    />

                    <TextWrapper>
                        <TextContainer>
                            {this.props.smallTitle &&
                                <SmallTitle>{this.props.smallTitle}</SmallTitle>
                            }
                            {isAndroidChrome ?
                                <Title isAndroidChrome={isAndroidChrome}>
                                    {this.state.width <= 500 &&
                                          androidChromeHyphenatedTitle ||
                                          header}
                                </Title>
                                :
                                <Title isAndroidChrome={isAndroidChrome}>
                                    {header}
                                </Title>
                            }

                            <Text>
                                {descriptionIsLink ?
                                    <Link to="/">{this.props.description}</Link>
                                    :
                                    this.props.description
                                }
                            </Text>
                        </TextContainer>
                    </TextWrapper>
                </Wrapper>

        )
    }
}

Hero.propTypes = {
    className: PropTypes.string,
    header: PropTypes.string,
    description: PropTypes.string,
    smallTitle: PropTypes.string,
    image: PropTypes.object,
    top: PropTypes.string,
    descriptionIsLink: PropTypes.bool,
    androidChromeHyphenatedTitle: PropTypes.string
}


Hero.defaultProps = {
    descriptionIsLink: false
}

export default Hero
